import Vue from'vue';export default{pixelHeight:462,pixelWidth:74,get ratio(){return{width:this.pixelHeight/this.heights.xl,height:this.pixelWidth/this.widths.xs}},step:6.4,initial_step:3.5,heights:{xs:57,s:96,m:146,l:198,xl:249},widths:{xs:40,s:60,m:75.5,l:90}};


//////////////////
// WEBPACK FOOTER
// ./app/components/data/k1.js
// module id = 209
// module chunks = 0